import React from 'react'
import { Link } from 'gatsby'
import Nav from './styles'

const Pagination = ({ pageContext }) => {
  const { numberOfPages, pageNumber, humanPageNumber } = pageContext

  return (
    <Nav role="navigation">
      <ul>
        {pageNumber < 4 && (
          <>
            <li>
              {pageNumber === 0 ? (
                <span className="ativa">1</span>
              ) : (
                <Link to="/blog/">1</Link>
              )}
            </li>
            <li>
              {pageNumber === 1 ? (
                <span className="ativa">2</span>
              ) : (
                <Link to="/blog/pagina/2">2</Link>
              )}
            </li>
            <li>
              {pageNumber === 2 ? (
                <span className="ativa">3</span>
              ) : (
                <Link to="/blog/pagina/3">3</Link>
              )}
            </li>
            <li>
              {pageNumber === 3 ? (
                <span className="ativa">4</span>
              ) : (
                <Link to="/blog/pagina/4">4</Link>
              )}
            </li>
            <li>
              {pageNumber === 4 ? (
                <span className="ativa">5</span>
              ) : (
                <Link to="/blog/pagina/5">5</Link>
              )}
            </li>
          </>
        )}
        {pageNumber >= 4 && humanPageNumber < numberOfPages ? (
          <>
            <li>
              <Link to="/blog/">1</Link>
            </li>
            <li>
              <span>...</span>
            </li>
            <li>
              <Link to={`/blog/pagina/${humanPageNumber - 1}`}>
                {humanPageNumber - 1}
              </Link>
            </li>
            <li>
              <span className="ativa">{humanPageNumber}</span>
            </li>
            <li>
              <Link to={`/blog/pagina/${humanPageNumber + 1}`}>
                {humanPageNumber + 1}
              </Link>
            </li>
          </>
        ) : (
          ''
        )}

        {humanPageNumber === numberOfPages && (
          <li>
            <Link to="/blog/">1</Link>
          </li>
        )}
        {numberOfPages >= 3 && (
          <li>
            <span>...</span>
          </li>
        )}

        {humanPageNumber === numberOfPages ? (
          <>
            <li>
              <Link to={`/blog/pagina/${numberOfPages - 2}`}>
                {numberOfPages - 2}
              </Link>
            </li>
            <li>
              <Link to={`/blog/pagina/${numberOfPages - 1}`}>
                {numberOfPages - 1}
              </Link>
            </li>
            <li>
              <span className="ativa">{numberOfPages}</span>
            </li>
          </>
        ) : (
          <li>
            <Link to={`/blog/pagina/${numberOfPages}`}>{numberOfPages}</Link>
          </li>
        )}
      </ul>
    </Nav>
  )
}

export default Pagination
